import {
  IVideoMutationForm,
  IVideoResponse,
  TRACK_CENSORIOUS,
} from 'services/video/types';

export const videoQueryToForm = (
  videoQuery: IVideoResponse
): IVideoMutationForm => {
  const { videoStatus, instrumental, ...video } = {
    ...videoQuery,
    censorious: videoQuery.censorious ?? TRACK_CENSORIOUS.unknown,
    genre:
      videoQuery.genre !== null && videoQuery.genre.id !== -1
        ? { id: videoQuery.genre.id, name: videoQuery.genre.name }
        : { id: -1, name: '' },
    status: videoQuery.videoStatus,
    isrc: videoQuery.isrc ?? '',
    pline: videoQuery.pline?.name?.length
      ? videoQuery.pline
      : { name: '', year: '' },
    cline: videoQuery.cline?.name?.length
      ? videoQuery.cline
      : { name: '', year: '' },
    isInstrumental: videoQuery.instrumental ?? true,
    artists: videoQuery.artists.map(({ rolePlacement, ...artist }) => ({
      ...artist,
    })),
    contracts: videoQuery.contracts || [],
  };

  return video;
};
